import { render, staticRenderFns } from "./VariantRecipeEditor.vue?vue&type=template&id=1d2e9d92&scoped=true&"
import script from "./VariantRecipeEditor.vue?vue&type=script&lang=js&"
export * from "./VariantRecipeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e9d92",
  null
  
)

export default component.exports